<template>
  <div class="buy-config-input-group">
    <label
      >{{ formLabel }}

      <button v-if="!tooltipDisabled" type="button" class="tooltip text-xs">
        &#9432;
        <span class="tooltip-text tooltip-top">{{ tooltip }}</span>
      </button>
    </label>
    <div class="input-with-append">
      <input
        type="number"
        class="input-number"
        :value="modelValue"
        @input="$emit('update:modelValue', Number($event.target.value))"
        :disabled="disabled"
      />
      <button type="button" class="btn-no-hover">{{ suffix }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputField",
  props: {
    modelValue: Number,
    formLabel: String,

    suffix: String,
    tooltip: String,
    tooltipDisabled: Boolean,
    disabled: Boolean,
  },
};
</script>
<style scoped>
/* 스타일 */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
